<template>
  <v-container class="fill-height justify-center">
    <div class="d-flex justify-center align-center">
      <v-card elevation="0">
        <v-card-text>
          <v-row class="justify-space-between align-center">
            <v-col v-if="!isBpkpad" cols="12" :md="isKadis ? 4 : 3">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" :to="'/statistik'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                      <v-icon size="60" color="#E65100">mdi-chart-bar-stacked</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    statistik
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col v-if="!isRestrictedRole" cols="12" md="3">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/product'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                    <v-icon size="60" color="success">mdi-book-open-blank-variant</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Fasilitas Umum
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col v-if="!isKadis" cols="12" :md="isRestrictedRole ? (isKadis ? 4 : 12) : 3">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/order'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                    <v-icon size="60" color="primary">mdi-order-bool-descending</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Daftar Pemakaian / Penggunaan
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col v-if="isAdmin || isKadis" cols="12" :md="isKadis ? 4 : 3">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/tandatangan'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                    <v-icon size="60" color="#1565C0">mdi-draw</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Tanda Tangan
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col v-if="isKadis" cols="12" md="4">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/log-esign'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                    <v-icon size="60" color="#097640">mdi-draw</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Log E-Sign
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col v-if="!isRestrictedRole" cols="12" md="3">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/agenda'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                    <v-icon size="60" color="#4A148C">mdi-calendar-month</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Agenda
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col v-if="!isRestrictedRole" cols="12" md="3">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/user'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                    <v-icon size="60" color="#3E2723">mdi-account-group</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Admin
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col v-if="!isRestrictedRole" cols="12" md="3">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/berita'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                    <v-icon size="60" color="#D81B60">mdi-newspaper-variant-outline</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Berita
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col v-if="!isRestrictedRole" cols="12" md="3">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/banner'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                    <v-icon size="60" color="#827717">mdi-image-area</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Banner
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col v-if="!isRestrictedRole" cols="12" md="3">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/hari-libur'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                    <v-icon size="60" color="#4A148C">mdi-clipboard-text-clock</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Hari Libur
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { TokenService } from "@/service/Storage.Service";
import { get, post, put, patch, destroy } from "@/service/Axios";
export default {
  data() {
    return {};
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    token() {
      return this.$store.state.token;
    },
    menu() {
      return this.$store.state.menu;
    },
    isAdmin() {
      return (this.$store.state.user && this.$store.state.user.role === 'admin') || false
    },
    isBpkpad() {
      return (this.$store.state.user && this.$store.state.user.role === 'bpkpad') || false
    },
    isKadis() {
      return (this.$store.state.user && this.$store.state.user.role === 'kadis') || false
    },
    isRestrictedRole() {
      return this.isBpkpad || this.isKadis
    },
  },

  mounted() {
  },

  methods: {
    logout() {
      TokenService.removeToken();
      window.location = "/login";
    },
  },
};
</script>

<style>
</style>